import { useEffect, useState } from 'react';
import { publicAPI } from '../services/api';

// Whether the server has paused starting payments (PAYMENTS_PAUSED, server/src/utils/paymentsPause.js).
// Every pay button / plan picker reads this so they all grey out together. The server refuses the
// payment calls either way — this only keeps the screens honest. If the status can't be fetched the
// buttons stay enabled and the server's refusal message is what the customer sees.
export const PAYMENTS_PAUSED_FALLBACK = 'Online payment is temporarily unavailable. Please contact us on WhatsApp to renew or change your plan.';

let cached = null; // { paused, message } once fetched
let inflight = null;

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = publicAPI.getPaymentsStatus()
      .then(({ data }) => { cached = { paused: !!data.paused, message: data.message || PAYMENTS_PAUSED_FALLBACK }; return cached; })
      .catch(() => ({ paused: false, message: PAYMENTS_PAUSED_FALLBACK }))
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const usePaymentsPaused = () => {
  const [state, setState] = useState(cached || { paused: false, message: PAYMENTS_PAUSED_FALLBACK });
  useEffect(() => {
    let alive = true;
    // Re-read on every mount so flipping the switch shows up on the next page load, not only after a restart.
    cached = null;
    load().then((s) => { if (alive) setState(s); });
    return () => { alive = false; };
  }, []);
  return state;
};
